import { useEffect, useState } from 'preact/hooks';
import { Button } from './Button.jsx';

const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream;

export function InstallHint() {
  const [prompt, setPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(() => !!localStorage.getItem('sps:installDismissed'));

  useEffect(() => {
    const onBIP = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', onBIP);
    return () => window.removeEventListener('beforeinstallprompt', onBIP);
  }, []);

  if (dismissed) return null;
  if (!prompt && !isIOS) return null;

  return (
    <div
      style={{
        padding: 12,
        background: 'var(--card)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        margin: 12,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}
    >
      <div style={{ flex: 1 }}>
        Install this app for offline use.
        {isIOS && (
          <div style={{ color: 'var(--muted)', fontSize: 13 }}>Tap Share → Add to Home Screen.</div>
        )}
      </div>
      {prompt && (
        <Button
          variant="primary"
          onClick={async () => {
            await prompt.prompt();
            setDismissed(true);
          }}
        >
          Install
        </Button>
      )}
      <Button
        onClick={() => {
          setDismissed(true);
          localStorage.setItem('sps:installDismissed', '1');
        }}
      >
        Dismiss
      </Button>
    </div>
  );
}
